import React ,{createContext} from 'react';
const TermsContext= createContext({Terms:[]})


export default TermsContext;